export const UI_SELECT: string = "ui_slider";
export const UI_CLICK: string = "button_active";
export const GOOD_PICK: string = "goodpick";
export const DEAD_CLICK: string = "button_inactive";
export const BAD_PICK: string = "badpick";
export const COLLISION: string = "collision";
export const TALLY: string = "tally";
export const ENERGY_REFILL: string = "energyrefill_2";
export const WING_FLAPPING: string = "wing_flapping";
export const OBSTACLE_WIND: string = "gust";
export const OBSTACLE_GULL: string = "seagull";
export const FANFARE: string = "fanfare";
export const BADGE: string = "badgepopup";
